import axios from 'axios';

class ConversationGateway {
  constructor({ config }) {
    this.config = {};
    this.config.baseURL = config.ConversationAPI.url;
    this.config.model = config.Model.name;
    this.client = axios.create({
      baseURL: this.config.baseURL,
      timeout: 100000,
    });
    this.cache = {
      expires: 0,
      data: [],
      isExpired: () => Date.now() > this.cache.expires,
      set: (data, expiry) => {
        this.cache.expires = Date.now() + expiry;
        this.cache.data = data;
      },
      get: () => this.cache.data,
    };
  }

  async generate(newMessage) {
    try {

      const response = await this.client.post('/generate', {
        input: {prompt: newMessage},
      },);

      const assistantMessage = response.data;

      return assistantMessage;
    } catch (error) {
      console.error('Error transmitting messages:', error);
      throw error;
    }
  }

  async chat(newMessage, onChunkReceived) {
    try {
      const response = await fetch(`${this.config.baseURL}/chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ input: { messages: newMessage } })
      },);

      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');

      let done = false;
      let buffer = '';

      while (!done) {
        const { value, done: readerDone } = await reader.read();
        done = readerDone;
        buffer += decoder.decode(value, { stream: true });
        
        let boundary = buffer.indexOf('\n');
        while (boundary !== -1) {
          const chunk = buffer.slice(0, boundary);
          buffer = buffer.slice(boundary + 1);
          if (chunk.trim()) {
            try {
              const data = JSON.parse(chunk);
              onChunkReceived(data);
            } catch (error) {
              console.error('Error parsing JSON:', error);
              throw error;
            }
          }
          boundary = buffer.indexOf('\n');
        }
      }
      return;
    } catch (error) {
      console.error('Error transmitting messages:', error);
      throw error;
    }
  }
  async fetchSystemPrompt() {
    try {
      const response = await this.client.get('/prompt/system');

      const prompt = response.data;

      return prompt;
    } catch (error) {
      console.error('Error transmitting messages:', error);
      throw error;
    }
  }
  async updateSystemPrompt(prompt) {
    try {

      const response = await this.client.post('/prompt/system/update', {
        input: {prompt: prompt, model: this.config.model},
      },);

      const assistantMessage = response.data;

      return assistantMessage;
    } catch (error) {
      console.error('Error transmitting messages:', error);
      throw error;
    }
  }
}

export default ConversationGateway;